import { ApexOptions } from 'apexcharts';

import { VulsPeriodChartResponse } from 'api/analitics/VulCharts/types';
import { TFunction } from 'i18next';

export const vulCurrentTypeLineChartOptions = (
  chartData: VulsPeriodChartResponse,
  t: TFunction,
  vulType: string,
): ApexOptions => {
  const months = chartData ? Object.keys(chartData) : [];
  const createdData = chartData
    ? months.map(month => chartData[month][vulType as keyof (typeof chartData)[string]]?.created || 0)
    : [];
  const closedData = chartData
    ? months.map(month => chartData[month][vulType as keyof (typeof chartData)[string]]?.closed || 0)
    : [];

  return {
    chart: {
      height: 350,
      type: 'area',
      toolbar: {
        show: false,
      },
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return val > 0 ? val.toString() : '';
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
      },
      background: {
        enabled: true,
        foreColor: '#fff',
        padding: 4,
        borderRadius: 2,
        borderWidth: 1,
        borderColor: '#6a37d4',
        opacity: 0.9,
      },
    },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    series: [
      {
        name: t('ChartsAnalitics.vuls_period_line_chart.create'),
        data: createdData,
      },
      {
        name: t('ChartsAnalitics.vuls_period_line_chart.closed'),
        data: closedData,
      },
    ],
    xaxis: {
      type: 'category',
      categories: months,
    },
    colors: ['#6a37d4', '#0ab39c'],
    fill: {
      type: 'gradient',
      gradient: {
        shadeIntensity: 1,
        inverseColors: false,
        opacityFrom: 0.45,
        opacityTo: 0.05,
        stops: [20, 100, 100, 100],
      },
    },
    tooltip: {
      theme: 'dark',
    },
    legend: {
      position: 'top',
      horizontalAlign: 'right',
      floating: true,
      offsetY: -25,
      offsetX: -5,
      labels: {
        colors: ['#fff'],
      },
    },
    grid: {
      borderColor: '#f1f1f1',
    },
  };
};
